import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultHousewife = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.HAUSFRAU }>;
} => ({
    beschaeftigung: {
        beschaeftigungsart: EMPLOYMENT_TYPES.HAUSFRAU,
        hausfrau: {
            sonstigesEinkommenMonatlich: null,
        },
        steuerklasse: null,
    },
});
export default getDefaultHousewife;
